exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".minusplusnumber[data-v-6b4e5c06]{border:1px solid silver;border-radius:5px;xbackground-color:#a2cb5a;Xmargin:0 5px 0 5px;display:inline-block;user-select:none}.minusplusnumber div[data-v-6b4e5c06]{display:inline-block}.minusplusnumber #field_container input[data-v-6b4e5c06]{width:35px;text-align:center;font-size:12px;padding:3px;border:none;background-color:#fff;color:#000}.minusplusnumber .mpbtn[data-v-6b4e5c06]{padding:3px 10px;cursor:pointer;border-radius:5px;color:#fff;font-size:.9167em;font-weight:600;background-color:#a2cb5a}.minusplusnumber .mpbtn[data-v-6b4e5c06]:hover{background-color:#81a04c}.minusplusnumber .mpbtn[data-v-6b4e5c06]:active{background-color:#6e8842}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6b4e5c06","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/fields/PlusMinusField.vue
// module id = 466
// module chunks = 0